import { Get } from "domain/infra/data/api";
import DomainConstants from "../../infra/data/domainConstants";
import { UsuarioSistemaPerfilResponse } from "../../types/usuarioSistemaPerfil/usuarioSistemaPerfilResponse";

export class UsuarioSistemaPerfilService {
  constructor() {
    // Constructor implementation
  }

  async GetUsuarioSistemaPerfil(usuarioID: number): Promise<UsuarioSistemaPerfilResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.usuarioSistemaPerfil.getUsuarioSistemaPerfil}?usuarioId=${usuarioID}`);
  }
}
